export const LOAD_TRACK_CASH_REQUEST_APPROVALS = "LOAD_TRACK_CASH_REQUEST_APPROVALS"
export const loadTrackCashRequestApprovalsAction = pagination => ({
   type: LOAD_TRACK_CASH_REQUEST_APPROVALS,
   payload: pagination
})